function youtubeId(youtubeLink) {
  let id;

  const regexes = [
    /^.*(?:(?:youtu\.be\/|v\/|shorts\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/,
  ];

  regexes.forEach((regex) => {
    const match = regex.exec(youtubeLink);
    if (match && match.length > 1 && match[1]) {
      id = match[1];
    }
  });

  return id;
}

export { youtubeId };
